export const getters = {
  GET_LIFFID (state) {
    return state.liffId
  },
  liffIsReady (state) {
    return state.liffReady
  },
  getLiffProfile (state) {
    return state.liffProfile
  }
}



// WEBPACK FOOTER //
// ./src/store/line/getters.js